import { createSlice } from "@reduxjs/toolkit";

const customersSlice = createSlice({
  name: "userAdmin",
  initialState: {
    customerSelected: null,
  },
  reducers: {
    setCustomerSelected: (state, action) => {
      state.customerSelected = action.payload;
    },
  },
});

export const { setCustomerSelected } = customersSlice.actions;
export default customersSlice.reducer;
